import "../OperazioniHr/OperazioniHr.css"

import FiltroCategorie from "../../components/FiltroCategorie/FiltroCategorie";
import DatePickerModal from "../../components/DatePickerModal/DatePickerModal";
import DettaglioGg from "./DettaglioGG/DettaglioGg";
import AssegnazioniGg from "./AssegnazioniGG/AssegnazioniGg";

import { useState, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import Select, { components } from "react-select";
import { MOCKED_HR_DETTAGLIO_CATEGORIES } from "../../mocks/MockedCategories";

// Componente custom per mostrare numero elementi selezionati nei Select multi
const MultiValueContainer = ({ children, selectProps, data, ...props }) => {
    const values = selectProps.value || [];
    const index = values.findIndex(v => v.value === data.value);

    if (index < 2) {
        return <components.MultiValue selectProps={selectProps} data={data} {...props}>{children}</components.MultiValue>;
    }
    if (index === 2 && values.length > 2) {
        return (
            <div className="oper-hr-select-more-badge">
                +{values.length - 2}
            </div>
        );
    }
    return null;
};

const formatDate = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
};

const FIXED_FROM_DATE = "2023-09-11";
const defaultToDate = formatDate(new Date());

export const HrDettaglio = () => {
    const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001/api";
    const navigate = useNavigate();

    const [showInfoModal, setShowInfoModal] = useState(false);
    const [showFiltersPanel, setShowFiltersPanel] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState("");
    const [loading, setLoading] = useState(false);

    // stati filtri
    const [toDate, setToDate] = useState(defaultToDate);
    const [selectedSettore, setSelectedSettore] = useState([]);
    const [selectedTipoContratto, setSelectedTipoContratto] = useState([]);
    const [selectedDettaglioContratto, setSelectedDettaglioContratto] = useState([]);
    const [selectedMotivoCessazione, setSelectedMotivoCessazione] = useState([]);
    const [selectedSesso, setSelectedSesso] = useState([]);
    const [selectedEta, setSelectedEta] = useState([]);

    // stati filtri applicati
    const [appliedFilters, setAppliedFilters] = useState({
        fromDate: FIXED_FROM_DATE,
        toDate: defaultToDate,
        settore: [],
        tipoContratto: [],
        dettaglioContratto: [],
        motivoCessazione: [],
        sesso: [],
        eta: []
    });

    // opzioni filtri
    const [filterOptions, setFilterOptions] = useState({
        settore: [],
        tipoContratto: [],
        dettaglioContratto: [],
        motivoCessazione: [],
        sesso: [],
        eta: []
    });

    const handleApply = useCallback(() => {
        setAppliedFilters({
            fromDate: FIXED_FROM_DATE,
            toDate,
            settore: selectedSettore,
            tipoContratto: selectedTipoContratto,
            dettaglioContratto: selectedDettaglioContratto,
            motivoCessazione: selectedMotivoCessazione,
            sesso: selectedSesso,
            eta: selectedEta
        });
    }, [toDate, selectedSettore, selectedTipoContratto, selectedDettaglioContratto, selectedMotivoCessazione, selectedSesso, selectedEta]);

    const handleReset = useCallback(() => {
        setToDate(defaultToDate);
        setSelectedSettore([]);
        setSelectedTipoContratto([]);
        setSelectedDettaglioContratto([]);
        setSelectedMotivoCessazione([]);
        setSelectedSesso([]);
        setSelectedEta([]);
        setAppliedFilters({
            fromDate: FIXED_FROM_DATE,
            toDate: defaultToDate,
            settore: [],
            tipoContratto: [],
            dettaglioContratto: [],
            motivoCessazione: [],
            sesso: [],
            eta: []
        });
    }, []);

    useEffect(() => {
        const fetchFilters = async () => {
            try {
                const res = await axios.get(`${API_URL}/hr-dettaglio/filters`);
                setFilterOptions({
                    settore: res.data.settore.map(s => ({ value: s.id, label: s.valore })),
                    tipoContratto: res.data.tipoContratto.map(tc => ({ value: tc.id, label: tc.valore })),
                    dettaglioContratto: res.data.dettaglioContratto.map(dc => ({ value: dc.id, label: dc.valore })),
                    motivoCessazione: res.data.motivoCessazione.map(m => ({ value: m.id, label: m.valore })),
                    sesso: res.data.sesso.map(s => ({ value: s.id, label: s.valore })),
                    eta: res.data.eta.map(e => ({ value: e.id, label: e.valore }))
                });
            } catch (error) {
                console.error("Errore nel caricamento dei filtri:", error);
            }
        };
        fetchFilters();
    }, [API_URL]);

    return (
        <div className="operazioni-hr-page">
            <header className="oper-hr-header">
                <div className="oper-hr-header-content">
                    <button className="oper-hr-back-btn" onClick={() => navigate('/reportistica')}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="15 18 9 12 15 6"></polyline>
                        </svg>
                        Indietro
                    </button>

                    <div className="oper-hr-header-title">
                        <div className="oper-hr-title-row">
                            <h1>HR Dettaglio</h1>
                            <button className="oper-hr-info-btn" onClick={() => setShowInfoModal(true)} title="Informazioni">
                                <span>i</span>
                            </button>
                        </div>
                        <p className="oper-hr-subtitle">Dettaglio risorse umane per giornata</p>
                    </div>
                </div>
            </header>

            {/* Modal Info */}
            {showInfoModal && (
                <div className="oper-hr-modal-overlay" onClick={() => setShowInfoModal(false)}>
                    <div className="oper-hr-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="oper-hr-modal-header">
                            <div className="oper-hr-modal-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <line x1="12" y1="16" x2="12" y2="12"></line>
                                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                                </svg>
                            </div>
                            <h3>Informazioni sulla pagina</h3>
                            <button className="oper-hr-modal-close" onClick={() => setShowInfoModal(false)}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <line x1="18" y1="6" x2="6" y2="18"></line>
                                    <line x1="6" y1="6" x2="18" y2="18"></line>
                                </svg>
                            </button>
                        </div>
                        <div className="oper-hr-modal-body">
                            <div className="oper-hr-modal-section">
                                <h4>Cosa fa questa pagina?</h4>
                                <p>
                                    Questa pagina permette di analizzare nel dettaglio i dati HR giornalieri:
                                    numero persone attive, distribuzione per filiale, genere, livello,
                                    tipo contratto, eta media, monte ore e percentuale svantaggiati.
                                </p>
                            </div>
                            <div className="oper-hr-modal-section">
                                <h4>Come utilizzarla?</h4>
                                <ul>
                                    <li><strong>Filtri:</strong> Applica filtri per data, settore, tipo contratto, dettaglio contratto, motivo cessazione, sesso ed eta</li>
                                    <li><strong>Dettaglio per GG:</strong> Visualizza i KPI e le distribuzioni HR per il giorno selezionato con grafici per filiale, genere, livello e tipo contratto</li>
                                    <li><strong>Assegnazioni per GG:</strong> Consulta il dettaglio delle assegnazioni giornaliere delle risorse</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <main className="oper-hr-main">

                {/* Bottone Mostra Filtri */}
                <div className="oper-hr-actions">
                    <button
                        type="button"
                        className={`oper-hr-action-btn ${showFiltersPanel ? 'active' : ''}`}
                        onClick={() => setShowFiltersPanel(prev => !prev)}
                    >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
                        </svg>
                        <span>{showFiltersPanel ? 'Nascondi Filtri' : 'Mostra Filtri'}</span>
                    </button>
                </div>

                {/* Pannello Filtri */}
                {showFiltersPanel && (
                    <div className="oper-hr-panel">
                        <div className="oper-hr-filters-grid">
                            <div className="oper-hr-filter-item">
                                <label>Data</label>
                                <DatePickerModal
                                    value={toDate}
                                    onChange={(e) => setToDate(e.target.value)}
                                    min={FIXED_FROM_DATE}
                                    label="Data"
                                />
                            </div>

                            <div className="oper-hr-filter-item">
                                <label>Settore</label>
                                <Select
                                    classNamePrefix="oper-hr-select"
                                    placeholder="Tutte"
                                    value={selectedSettore}
                                    options={filterOptions.settore}
                                    onChange={setSelectedSettore}
                                    isMulti
                                    components={{ MultiValue: MultiValueContainer }}
                                    hideSelectedOptions={false}
                                    closeMenuOnSelect={false}
                                />
                            </div>

                            <div className="oper-hr-filter-item">
                                <label>Tipo Contratto</label>
                                <Select
                                    classNamePrefix="oper-hr-select"
                                    placeholder="Tutte"
                                    value={selectedTipoContratto}
                                    options={filterOptions.tipoContratto}
                                    onChange={setSelectedTipoContratto}
                                    isMulti
                                    components={{ MultiValue: MultiValueContainer }}
                                    hideSelectedOptions={false}
                                    closeMenuOnSelect={false}
                                />
                            </div>

                            <div className="oper-hr-filter-item">
                                <label>Dettaglio Contratto</label>
                                <Select
                                    classNamePrefix="oper-hr-select"
                                    placeholder="Tutte"
                                    value={selectedDettaglioContratto}
                                    options={filterOptions.dettaglioContratto}
                                    onChange={setSelectedDettaglioContratto}
                                    isMulti
                                    components={{ MultiValue: MultiValueContainer }}
                                    hideSelectedOptions={false}
                                    closeMenuOnSelect={false}
                                />
                            </div>

                            <div className="oper-hr-filter-item">
                                <label>Motivo Cessazione</label>
                                <Select
                                    classNamePrefix="oper-hr-select"
                                    placeholder="Tutte"
                                    value={selectedMotivoCessazione}
                                    options={filterOptions.motivoCessazione}
                                    onChange={setSelectedMotivoCessazione}
                                    isMulti
                                    components={{ MultiValue: MultiValueContainer }}
                                    hideSelectedOptions={false}
                                    closeMenuOnSelect={false}
                                />
                            </div>

                            <div className="oper-hr-filter-item">
                                <label>Sesso</label>
                                <Select
                                    classNamePrefix="oper-hr-select"
                                    placeholder="Tutte"
                                    value={selectedSesso}
                                    options={filterOptions.sesso}
                                    onChange={setSelectedSesso}
                                    isMulti
                                    components={{ MultiValue: MultiValueContainer }}
                                    hideSelectedOptions={false}
                                    closeMenuOnSelect={false}
                                />
                            </div>

                            <div className="oper-hr-filter-item">
                                <label>Eta</label>
                                <Select
                                    classNamePrefix="oper-hr-select"
                                    placeholder="Tutte"
                                    value={selectedEta}
                                    options={filterOptions.eta}
                                    onChange={setSelectedEta}
                                    isMulti
                                    components={{ MultiValue: MultiValueContainer }}
                                    hideSelectedOptions={false}
                                    closeMenuOnSelect={false}
                                />
                            </div>

                            <div className="oper-hr-filter-actions">
                                <button type="button" className="oper-hr-btn-primary" onClick={handleApply}>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    Applica
                                </button>
                                <button type="button" className="oper-hr-btn-secondary" onClick={handleReset}>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
                                        <path d="M3 3v5h5"></path>
                                    </svg>
                                    Reset
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Tab + Contenuto */}
                <div className="oper-hr-data-section">
                    <FiltroCategorie
                        categories={MOCKED_HR_DETTAGLIO_CATEGORIES}
                        filteredCategory={setSelectedCategory}
                        customCss={"reportistica-section"}
                    />

                    {selectedCategory === "Dettaglio per GG" && (
                        <DettaglioGg filters={appliedFilters} loading={loading} />
                    )}

                    {selectedCategory === "Assegnazioni per GG" && (
                        <AssegnazioniGg filters={appliedFilters} loading={loading} />
                    )}
                </div>
            </main>
        </div>
    )
}

export default HrDettaglio;
